// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-pages-Project-Settings-FollowUp-AttributesEditor-___AttributesEditor-module__container {
  display: flex;
  flex-direction: column;
}

.app-pages-Project-Settings-FollowUp-AttributesEditor-___AttributesEditor-module__subContainer {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  margin-top: 10px;
}

.app-pages-Project-Settings-FollowUp-AttributesEditor-___AttributesEditor-module__block {
  height: 250px;
  padding-left: 15px;
}

.app-pages-Project-Settings-FollowUp-AttributesEditor-___AttributesEditor-module__toolbar {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  flex-wrap: nowrap;
}

.app-pages-Project-Settings-FollowUp-AttributesEditor-___AttributesEditor-module__scrollBlock {
  max-height: 250px;
  overflow-y: auto;
}

.app-pages-Project-Settings-FollowUp-AttributesEditor-___AttributesEditor-module__listItemContainer,
.app-pages-Project-Settings-FollowUp-AttributesEditor-___AttributesEditor-module__listItemContainerSelected {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
}

.app-pages-Project-Settings-FollowUp-AttributesEditor-___AttributesEditor-module__listItemContainerSelected {
  background-color: rgba(0, 0, 0, 0.12);
}

.app-pages-Project-Settings-FollowUp-AttributesEditor-___AttributesEditor-module__attributeLabel {
  width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.app-pages-Project-Settings-FollowUp-AttributesEditor-___AttributesEditor-module__listItem__actionContainer {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-content: center;
  flex-wrap: nowrap;
}

.app-pages-Project-Settings-FollowUp-AttributesEditor-___AttributesEditor-module__displayAttribute {
  max-width: 400px;
  min-width: 270px;
  height: 250px;
}

.app-pages-Project-Settings-FollowUp-AttributesEditor-___AttributesEditor-module__displayAttributeContainer {
  width: 100%;
  height: 100%;
  position: relative;
  padding-left: 10px;
}

.app-pages-Project-Settings-FollowUp-AttributesEditor-___AttributesEditor-module__displayAttributeEditButtons {
  float: right;
  width: -moz-fit-content;
  width: fit-content;
  height: 20px;
}

.app-pages-Project-Settings-FollowUp-AttributesEditor-___AttributesEditor-module__attributeInfo > :nth-child(1) {
  margin-right: 5px;
  font-weight: bold;
  white-space: nowrap;
}

.app-pages-Project-Settings-FollowUp-AttributesEditor-___AttributesEditor-module__attributeInfo > :nth-child(2) {
  font-weight: normal;
  max-width: 100%;
  overflow-wrap: break-word;
}

.app-pages-Project-Settings-FollowUp-AttributesEditor-___AttributesEditor-module__attributeRequired {
  float: right;
  display: inline;
  margin-top: 5px;
  padding: 0px 6px;
  border-radius: 3px;
  border: 1px solid var(--colors-red) 77;
  background-color: var(--colors-red);
  color: #ffffff;
  font-weight: bold;
}

.app-pages-Project-Settings-FollowUp-AttributesEditor-___AttributesEditor-module__iconButton {
  padding: 4px;
  border-radius: 4px;
  color: var(--colors-black);
  margin: 0 2px;
  transition: 0.2s;
  cursor: pointer;
}

.app-pages-Project-Settings-FollowUp-AttributesEditor-___AttributesEditor-module__iconButton:hover {
  background-color: var(--colors-black);
  color: #ffffff;
}

.app-pages-Project-Settings-FollowUp-AttributesEditor-___AttributesEditor-module__iconButtonSelected {
  background-color: none;
  color: #ffffff;
}

.app-pages-Project-Settings-FollowUp-AttributesEditor-___AttributesEditor-module__noAttributeItem {
  width: 270px;
  height: 250px;
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
}

.app-pages-Project-Settings-FollowUp-AttributesEditor-___AttributesEditor-module__choiceTypeInput_container {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-end;
  width: 100%;
}

.app-pages-Project-Settings-FollowUp-AttributesEditor-___AttributesEditor-module__choiceTypeInput_checkbox {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  align-content: center;
}
`, "",{"version":3,"sources":["webpack://./app/pages/Project/Settings/FollowUp/AttributesEditor/AttributesEditor.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,uBAAkB;EAAlB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,sCAAsC;EACtC,mCAAmC;EACnC,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;EAC1B,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,qBAAqB;AACvB","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n}\n\n.subContainer {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  margin-top: 10px;\n}\n\n.block {\n  height: 250px;\n  padding-left: 15px;\n}\n\n.toolbar {\n  display: flex;\n  justify-content: space-between;\n  flex-direction: row;\n  flex-wrap: nowrap;\n}\n\n.scrollBlock {\n  max-height: 250px;\n  overflow-y: auto;\n}\n\n.listItemContainer,\n.listItemContainerSelected {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.listItemContainerSelected {\n  background-color: rgba(0, 0, 0, 0.12);\n}\n\n.attributeLabel {\n  width: 200px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.listItem__actionContainer {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-content: center;\n  flex-wrap: nowrap;\n}\n\n.displayAttribute {\n  max-width: 400px;\n  min-width: 270px;\n  height: 250px;\n}\n\n.displayAttributeContainer {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  padding-left: 10px;\n}\n\n.displayAttributeEditButtons {\n  float: right;\n  width: fit-content;\n  height: 20px;\n}\n\n.attributeInfo > :nth-child(1) {\n  margin-right: 5px;\n  font-weight: bold;\n  white-space: nowrap;\n}\n\n.attributeInfo > :nth-child(2) {\n  font-weight: normal;\n  max-width: 100%;\n  overflow-wrap: break-word;\n}\n\n.attributeRequired {\n  float: right;\n  display: inline;\n  margin-top: 5px;\n  padding: 0px 6px;\n  border-radius: 3px;\n  border: 1px solid var(--colors-red) 77;\n  background-color: var(--colors-red);\n  color: #ffffff;\n  font-weight: bold;\n}\n\n.iconButton {\n  padding: 4px;\n  border-radius: 4px;\n  color: var(--colors-black);\n  margin: 0 2px;\n  transition: 0.2s;\n  cursor: pointer;\n}\n\n.iconButton:hover {\n  background-color: var(--colors-black);\n  color: #ffffff;\n}\n\n.iconButtonSelected {\n  background-color: none;\n  color: #ffffff;\n}\n\n.noAttributeItem {\n  width: 270px;\n  height: 250px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  align-content: center;\n}\n\n.choiceTypeInput_container {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  justify-content: flex-end;\n  width: 100%;\n}\n\n.choiceTypeInput_checkbox {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  align-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `app-pages-Project-Settings-FollowUp-AttributesEditor-___AttributesEditor-module__container`,
	"subContainer": `app-pages-Project-Settings-FollowUp-AttributesEditor-___AttributesEditor-module__subContainer`,
	"block": `app-pages-Project-Settings-FollowUp-AttributesEditor-___AttributesEditor-module__block`,
	"toolbar": `app-pages-Project-Settings-FollowUp-AttributesEditor-___AttributesEditor-module__toolbar`,
	"scrollBlock": `app-pages-Project-Settings-FollowUp-AttributesEditor-___AttributesEditor-module__scrollBlock`,
	"listItemContainer": `app-pages-Project-Settings-FollowUp-AttributesEditor-___AttributesEditor-module__listItemContainer`,
	"listItemContainerSelected": `app-pages-Project-Settings-FollowUp-AttributesEditor-___AttributesEditor-module__listItemContainerSelected`,
	"attributeLabel": `app-pages-Project-Settings-FollowUp-AttributesEditor-___AttributesEditor-module__attributeLabel`,
	"listItem__actionContainer": `app-pages-Project-Settings-FollowUp-AttributesEditor-___AttributesEditor-module__listItem__actionContainer`,
	"displayAttribute": `app-pages-Project-Settings-FollowUp-AttributesEditor-___AttributesEditor-module__displayAttribute`,
	"displayAttributeContainer": `app-pages-Project-Settings-FollowUp-AttributesEditor-___AttributesEditor-module__displayAttributeContainer`,
	"displayAttributeEditButtons": `app-pages-Project-Settings-FollowUp-AttributesEditor-___AttributesEditor-module__displayAttributeEditButtons`,
	"attributeInfo": `app-pages-Project-Settings-FollowUp-AttributesEditor-___AttributesEditor-module__attributeInfo`,
	"attributeRequired": `app-pages-Project-Settings-FollowUp-AttributesEditor-___AttributesEditor-module__attributeRequired`,
	"iconButton": `app-pages-Project-Settings-FollowUp-AttributesEditor-___AttributesEditor-module__iconButton`,
	"iconButtonSelected": `app-pages-Project-Settings-FollowUp-AttributesEditor-___AttributesEditor-module__iconButtonSelected`,
	"noAttributeItem": `app-pages-Project-Settings-FollowUp-AttributesEditor-___AttributesEditor-module__noAttributeItem`,
	"choiceTypeInput_container": `app-pages-Project-Settings-FollowUp-AttributesEditor-___AttributesEditor-module__choiceTypeInput_container`,
	"choiceTypeInput_checkbox": `app-pages-Project-Settings-FollowUp-AttributesEditor-___AttributesEditor-module__choiceTypeInput_checkbox`
};
export default ___CSS_LOADER_EXPORT___;
